import React from 'react';
import SlidePanel from '../shared/SlidePanel';

// The "?" next to the title: how codes work, in a few short answers.
const SALON = [
  ['What a code does', 'Clients type it when they book online, or show it at checkout. It takes a percentage or an amount off the services it covers, under the rules you set.'],
  ['One code per booking', 'A code can’t be added to a manual discount, another code or a loyalty reward. A gift card still pays whatever is left.'],
  ['Deposits', 'The deposit is never more than the client will pay after the code. Tips and fees are never discounted.'],
  ['Self-employed stylists', 'Each one chooses whether your codes can be used on their services: only when you pay, or shared in line with their split. Until they choose, your codes skip their services.'],
  ['Once it’s used', 'What it’s worth and its rules are fixed, so what clients were promised never changes. You can still pause it, end it early or move the end date with a reason.'],
  ['The small print', 'It’s written from your settings and goes with the code into posts, emails, texts and the booking page. Keep it wherever you share a code: UK advertising rules expect the conditions up front.'],
];

const STYLIST = [
  ['Your own codes', 'They only ever work on your services, and the discount comes out of your takings, never the business owner’s.'],
  ['The business owner’s codes', 'You decide whether they can be used on your services, in Settings, Your choices. Until you choose, they don’t.'],
  ['One code per booking', 'A code can’t be added to a manual discount, another code or a loyalty reward. A gift card still pays whatever is left.'],
  ['Once it’s used', 'What it’s worth and its rules are fixed. You can still pause it, end it early or move the end date with a reason.'],
  ['The small print', 'It’s written from your settings and goes with the code wherever you share it.'],
];

export default function DiscountsHelp({ selfEmployed, onClose }) {
  const rows = selfEmployed ? STYLIST : SALON;
  return (
    <SlidePanel title="How discount codes work" onClose={onClose} width={460} className="dc-page">
      <div className="dc-form" style={{ gap: 18 }}>
        {rows.map(([q, a]) => (
          <div key={q} className="dc-sec" style={{ gap: 4, borderTop: 0, paddingTop: 0 }}>
            <h3 className="dc-label" style={{ fontSize: 14 }}>{q}</h3>
            <p style={{ margin: 0, fontSize: 13.5, color: '#4b4b52', lineHeight: 1.55 }}>{a}</p>
          </div>
        ))}
      </div>
    </SlidePanel>
  );
}
